<template>
    <dash
        icon="fa fa-refresh"
        titulo="REABERTURAS DE ENTREGAS"
        subTitulo="SGF GESTOR"
        @click.native="
            $router.push({ name: 'Gestores_SolicitacoesReaberturas' })
        "
        :qtd="qtd"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
